export default class BaseModel {
  constructor() {
    this.id = null;
    this.description = null;
  }
}
